<template>
    <transition name="fade">
        <div class="modal is-active" v-show="visible">
            <div class="modal-background" @click="destroy"></div>
            <div class="modal-content">
                <div class="popup-dialog">
                    <div class="popup-title">
                        <h1 class="title is-1">{{ $t('admin.invoices.credit_note_form.title') }}</h1>

                        <div class="popup-close" @click.prevent="destroy">
                            <i class="icon">close</i>
                        </div>
                    </div>

                    <g-form
                        :form="form"
                        :action="`/api/admin/invoice/${this.id}/credit-note`"
                        :loading="isLoading"
                        @loading-state="(state) => isLoading = state"
                        @success="onSuccess"
                    >
                        <div class="popup-body">
                            <p>{{ $t('admin.invoices.credit_note_form.description', {number: invoiceNumber}) }}</p>

                            <div v-if="isSynced" class="notification is-warning is-small mt-3">
                                {{ $t('admin.invoices.credit_note_form.synced_warning') }}
                            </div>
                        </div>
                        <div class="popup-body popup-rows">
                            <div class="columns">
                                <div class="column is-one-third">
                                    <label>{{ $t('admin.invoices.credit_note_form.preset_reason') }}</label>
                                </div>
                                <div class="column">
                                    <div class="field-body">
                                        <g-select
                                            name="preset_reason"
                                            :options="presetReasons"
                                            valuekey="value"
                                        />
                                    </div>
                                </div>
                            </div>

                            <div class="columns">
                                <div class="column is-one-third">
                                    <label>{{ $t('admin.invoices.credit_note_form.reason') }}</label>
                                </div>
                                <div class="column">
                                    <div class="field-body">
                                        <g-input
                                            name="reason"
                                            type="textarea"
                                            autosize
                                            :label="$t('admin.invoices.credit_note_form.reason_placeholder')"
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="popup-footer">
                            <a @click.prevent="destroy" href="#" role="button">{{ $t('confirmation_dialog.deny') }}</a>
                            <g-button :loading="isLoading">{{
                                    $t('admin.invoices.credit_note_form.confirm')
                                }}
                            </g-button>
                        </div>
                    </g-form>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
export default {
    name: "InvoiceCreditNoteForm",
    data() {
        return {
            isLoading: false,
            form: new Form({
                preset_reason: '',
                reason: '',
            }),
            presetReasons: [
                {
                    value: '',
                    name: this.$t('admin.invoices.credit_note_form.preset_reasons.select'),
                },
                {
                    value: this.$t('admin.invoices.credit_note_form.preset_reasons.security_test_account'),
                    name: this.$t('admin.invoices.credit_note_form.preset_reasons.security_test_account'),
                },
                {
                    value: this.$t('admin.invoices.credit_note_form.preset_reasons.duplicate_invoice'),
                    name: this.$t('admin.invoices.credit_note_form.preset_reasons.duplicate_invoice'),
                },
                {
                    value: this.$t('admin.invoices.credit_note_form.preset_reasons.incorrect_amount'),
                    name: this.$t('admin.invoices.credit_note_form.preset_reasons.incorrect_amount'),
                },
                {
                    value: this.$t('admin.invoices.credit_note_form.preset_reasons.cancelled_service'),
                    name: this.$t('admin.invoices.credit_note_form.preset_reasons.cancelled_service'),
                },
                {
                    value: this.$t('admin.invoices.credit_note_form.preset_reasons.customer_request'),
                    name: this.$t('admin.invoices.credit_note_form.preset_reasons.customer_request'),
                },
                {
                    value: this.$t('admin.invoices.credit_note_form.preset_reasons.billing_error'),
                    name: this.$t('admin.invoices.credit_note_form.preset_reasons.billing_error'),
                },
            ]
        }
    },
    props: {
        id: {
            type: Number,
            required: true,
        },
        invoiceNumber: {
            type: String,
            required: true,
        },
        isSynced: {
            type: Boolean,
            default: false,
        },
    },
    watch: {
        'form.preset_reason'(value) {
            if (value) {
                this.form.reason = value
            }
        }
    },
    methods: {
        onSuccess(data) {
            this.$buefy.toast.open(this.$t('admin.invoices.credit_note_form.success', {
                number: data.credit_note_invoice.number
            }))
            this.$emit('success', data)
            this.destroy()
        }
    }
}
</script>
